var m = require('mithril');
var stream = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var auth = require('../../auth/models/session');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var calibrationLiveValue = require('./calibrationLiveValue');
var calibrationInstrumentOptions = require('./calibrationInstrumentOptions');
var alerts = require('../../layout/components/alerts'); 
var calibrationModel = require('../../../../../models/assets/calibration');
var calibrationValues = require('../../../../../models/assets/calibrationValues');
var Point = require('../../../../../models/data/point');
var Action = Object.create(Model);

Object.assign(Action, calibrationModel);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

var element

Action.editDialogue = function (record, options) {
  element = {
    in:
      record,
      permission:{
        write:0
      },
      noInteraction: true
  };
  
  Action.initForm({
    asset: record.asset ? record.asset['@rid'] : record.in_pointOf[record.in_pointOf.length - 1].out['@rid'],
    performedBy: auth.user()['@rid']
  });
  
  if (options.lastOffset) Action.form.offset(options.lastOffset);
  Action.getCertifiedInstruments = function() {
    loaders.requestWithLoader({
      url: '/api/v1/certifiedinstrument/usable',
      method: "GET"
    }).then(function(result) {
      Action.certifiedInstruments = result;
    })
  }
  Action.getCertifiedInstruments()

  var submit = function () {
    if (!calibrationInstrumentOptions.getValidCertifiedInstrument(Action.certifiedInstruments, Action.form.instrument())) {
      Action.errors = ['Select a valid certified instrument'];
      alerts.vm.add({detail: Action.errors[0]});
      m.redraw();
      return Promise.resolve();
    }

    var actionValues = calibrationValues.buildCalibrationActionValues(element.in.value, Action.form.offset());
    if (!actionValues.valid) {
      Action.errors = [actionValues.error];
      alerts.vm.add({detail: actionValues.error});
      m.redraw();
      return Promise.resolve();
    }

    Action.form.offset(actionValues.offset);
    Action.form.foundAs(actionValues.foundAs);
    Action.form.sourceReference(actionValues.sourceReference);
    Action.form.leftAs(actionValues.leftAs);
    Action.save()
    .then(function(data) {
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close()
    })
    .catch(function(e) {
        alerts.vm.add({detail: '' + e})
        console.log(e)
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Calibrate Point: ' + record.name)
  modal.vm.body = Action.view,
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open({ suppressPointUpdates: [record && record['@rid']] });
}


var result=stream(0)

var mapCertifiedInstrumentsToOptions = function () {
  var options = Action.certifiedInstruments.map(function (element) {
    var option = calibrationInstrumentOptions.buildCertifiedInstrumentOption(element);
    return m('option', {
      value: option.value,
      disabled: option.disabled ? 'disabled' : ''
    }, option.label);
  });
  return [
    m('option', {
      value: '',
      disabled: 'disabled'
    }, options.some(function (option) { return option.attrs && !option.attrs.disabled; }) ?
      'Select certified instrument' :
      'No valid certified instruments available'
    )
  ].concat(options);
};

Action.view = function () {
  if (!Action.certifiedInstruments) return
  if (!calibrationInstrumentOptions.getValidCertifiedInstrument(Action.certifiedInstruments, Action.form.instrument())) {
    Action.form.instrument(null);
  }
  result(calibrationValues.calculateCalibrationResult(element.in.value, element.in.offset, Action.form.offset()));
  return m('form', {role:'form'}, [
    Action.errorView(),
    m('label', {for:'certifiedInstruments-input'}, 'Certified Instrument:'),
    m('select.form-control', 
      {
        id:"certifiedInstruments-input",
        onchange: function (ev) { Action.form.instrument(ev.target.value || null) },
        value: Action.form.instrument() || ''
      }, 
      mapCertifiedInstrumentsToOptions()
    ),
    m('div.flex.flex-wrap.justify-between.mt3', [
      m('h4.w-33.mv1', 'Live Value'),
      m('h4.w-33.mv1', 'Offset'),
      m('h4.w-33.mv1', 'Result')
    ]),
    m('div.flex.flex-wrap.justify-between', [
      m('div.bg-dark-gray.w-33.pointer',[
        m(calibrationLiveValue, {columnRecord:element, options:{class: ' flex flex-column justify-center items-center h-100', keepPollingOnModalOpen: true, noInteraction: true}}),
      ]),
      m('div.bg-dark-gray.w-33', [
        m('input.h-100.tc.', {
          id:'offset-input', 
          type:'number', 
          oninput:  function (ev) {Action.form.offset(ev.target.value)},
          value: Action.form.offset(),
          style: {
            fontSize: '30px',
            backgroundColor: '#212121'
          }
        })
      ]),
      m('div.bg-dark-gray.w-33.pointer', [
        m('div.f4.flex.flex-column.justify-center.items-center.h-100', [
          m('div.moon-gray.blue', { style: {
              fontSize: '30px',
          }}, result() === null ? '--' : Number(result()).toFixed(4)),
        ])
      ])
    ])
  ])  
}

module.exports = Action;
